import React, { createContext, useContext, useState, useCallback, useEffect, lazy, Suspense } from "react";

// Loaded the first time someone asks for the form, so framer-motion and the
// embedded widget stay out of the initial page load.
const QuoteFormModal = lazy(() => import("@/components/QuoteFormModal"));

const QuoteFormContext = createContext<{ openQuoteForm: () => void }>({
  openQuoteForm: () => {},
});

export const useQuoteForm = () => useContext(QuoteFormContext);

export const QuoteFormProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false);
  // Once requested, the modal stays mounted so its exit animation can play.
  const [requested, setRequested] = useState(false);

  const openQuoteForm = useCallback(() => {
    setRequested(true);
    setOpen(true);
  }, []);
  const closeQuoteForm = useCallback(() => setOpen(false), []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <QuoteFormContext.Provider value={{ openQuoteForm }}>
      {children}
      {requested && (
        <Suspense fallback={null}>
          <QuoteFormModal open={open} onClose={closeQuoteForm} />
        </Suspense>
      )}
    </QuoteFormContext.Provider>
  );
};
